// Who has to fill in a timesheet (Karan 26/10/2026: "an option to omit
// mandatory timesheets for users, such as Pam, Steve, Meeting Room").
//
// users/{id}.timesheetExempt === true means "Not required" — set on Team by an
// Owner or Director through the setTimesheetRequired callable (the rules give
// the field to nobody else). Such a person can still log time and file a week,
// and a week they file is approved like anyone's; but nothing chases them:
// Approvals never counts them as missing or offers Remind, the server's
// remindTimesheets never emails them, the "sheets in" counts leave them out,
// and their own Time screen shows the hours logged without "expected · short".
// A room screen (roles only 'Display', or users.roomScreen === true — the
// Meeting Room account) is not a person and never needs one either (people.js,
// the one rule). Absent or false = required, as before.
// Pure: its only import is people.js (also pure), so the screens, the phone and
// the tests share it.
import { isScreen } from './people.js';

/** A room screen: roles only 'Display', or users.roomScreen (people.js). */
export { isScreen };

/** Set "Not required" on Team (only the boolean true counts). */
export const isTimesheetExempt = (u) => !!u && u.timesheetExempt === true;

/** Does this person have to fill in a timesheet? (Activity is the caller's question.) */
export const timesheetRequired = (u) => !!u && !isScreen(u) && !isTimesheetExempt(u);

/**
 * One week's team for Approvals and the "sheets in" figures.
 *   users    — the users docs
 *   byEmail  — the week's sheets by userEmail
 * Returns
 *   people   — who the table lists: everyone active who must file, plus anyone
 *              not required who DID file (their sheet can still be approved)
 *   required — active people who must file
 *   noSheet  — required people with nothing filed
 *   sheetsIn — required people with a sheet (the "N" of "N of M")
 *   exempt   — active people not required (room screens left out entirely)
 */
export function weekTeam({ users, byEmail }) {
  const has = (u) => !!(byEmail && u && u.email && byEmail[u.email]);
  const active = (users || []).filter((u) => u && u.active !== false && !isScreen(u));
  const required = active.filter(timesheetRequired);
  return {
    people: active.filter((u) => timesheetRequired(u) || has(u)),
    required,
    noSheet: required.filter((u) => !has(u)),
    sheetsIn: required.filter(has).length,
    exempt: active.filter(isTimesheetExempt),
  };
}
